import {ValidationResult} from '../interfaces/validation-result';
import {i18n, I18nUtil} from '../utils/i18n-util';

export let dateValidationRules = {
  i18n: i18n,
  validateIsDate: function validateIsDate(input: string, condition: any, context: any): ValidationResult {
    //console.log('validating isDate');
    let thisI18n = this.i18n;
    let result: ValidationResult = {
      isValid: thisI18n.isValidDate(input)
    };
    if (result.isValid) {
      context.parsedDate = thisI18n.deLocalizeDate(input);
    } else {
      result.errorMessage = this.i18n.getText('cu|validation engine|Must be a date');
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateMaxDate: function validateMaxDate(input: string, maxDate: Date, context: any): ValidationResult {
    //console.log('validating maxDate');
    let result: ValidationResult = {
      isValid: (<Date>context.parsedDate).getTime() <= maxDate.getTime()
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The date must be on or before xx', { maxDate: this.i18n.localizeDate(maxDate) });
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateMinDate: function validateMinDate(input: string, minDate: Date, context: any): ValidationResult {
    //console.log('validating minDate');
    let result: ValidationResult = {
      isValid: (<Date>context.parsedDate).getTime() >= minDate.getTime()
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The date must be on or after xx', { minDate: this.i18n.localizeDate(minDate) });
    }
    //console.log('result: ' + result.isValid);
    return result;
  }
};
